// @flow

import { CornerDownRight } from 'lucide-react';

import { useTranslator } from '@gandi/translate';
import { Fqdn } from '@gandi/ui';

import { InfoTooltip } from 'src/Reshaped/InfoTooltip';

import { ListRow } from '../../../ListRow';

import Price from '../components/Rows/Price';

type DomainRowProps = {
  matchedDomains: Array<string>,
  isWildcard?: boolean,
  price?: number,
};

export const DomainRow = ({
  matchedDomains,
  isWildcard,
  price,
}: DomainRowProps): React.MixedElement => {
  const { __ } = useTranslator();
  const count = matchedDomains.length;
  let title: React.Node;

  if (count === 1) {
    title = <Fqdn color="base">{matchedDomains[0]}</Fqdn>;
  } else {
    let text: string;
    if (isWildcard) {
      text = __('%(count)s wildcard domains', { count });
    } else if (price != null) {
      text = __('%(count)s unique domains', { count });
    } else {
      text = __('%(count)s domains', { count });
    }

    title = <InfoTooltip content={matchedDomains}>{text}</InfoTooltip>;
  }

  return (
    <ListRow
      icon={<CornerDownRight size={16} />}
      title={title}
      price={price != null ? <Price price={price} color="light" /> : null}
    />
  );
};
